var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackSlash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 28,
    viewBox: "0 0 36 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.00807 24.9251C2.09141 22.8168 0.941406 20.5168 0.941406 16.6835C0.941406 9.97513 5.73307 4.03346 12.4414 0.966797L14.1664 3.45846C7.84141 6.90846 6.49974 11.3168 6.11641 14.1918C7.07474 13.6168 8.41641 13.4251 9.75807 13.6168C13.2081 14.0001 15.8914 16.6835 15.8914 20.3251C15.8914 22.0501 15.1247 23.7751 13.9747 25.1168C12.6331 26.4585 11.0997 27.0335 9.18307 27.0335C7.07474 27.0335 5.15807 26.0751 4.00807 24.9251ZM23.1747 24.9251C21.2581 22.8168 20.1081 20.5168 20.1081 16.6835C20.1081 9.97513 24.8997 4.03346 31.6081 0.966797L33.3331 3.45846C27.0081 6.90846 25.6664 11.3168 25.2831 14.1918C26.2414 13.6168 27.5831 13.4251 28.9247 13.6168C32.3747 14.0001 35.0581 16.6835 35.0581 20.3251C35.0581 22.0501 34.2914 23.7751 33.1414 25.1168C31.9914 26.4585 30.2664 27.0335 28.3497 27.0335C26.2414 27.0335 24.3247 26.0751 23.1747 24.9251Z",
    fill: "url(#paint0_linear_665_28449)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_665_28449",
    x1: 17.9997,
    y1: 14.0001,
    x2: 40.0789,
    y2: 16.2196,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0B4A96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.884413,
    stopColor: "#5094E7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackSlash);
export default __webpack_public_path__ + "static/media/backSlash.34822eeacb1e785735f247671ff92de2.svg";
export { ForwardRef as ReactComponent };